<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      allMenu: []
    }
  },
  mounted () {},
  methods: {},
  components: {},
  created () {}
}
</script>
<style lang="less">
@import "assets/less/index.less";
#app {
  width: 100%;
  height: 100%;
}
.table-row-popover {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue